import { module } from 'modujs';
import gsap from "gsap";
import { onWidthResize } from '../utils/tickers';
import { getMediaType, getLottieById } from '../utils/medias';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                item: 'activateItem'
            }
        }
    }

    init() {
        this.type = this.el.classList.contains('-simple') ? 'simple' : 'multiple';

        this.interval = null;
        this.duration = 8;
        this.progressAnim = null;
        
        this.currentIndex = null;
        this.items = [...this.el.querySelectorAll('.c-carousel_contents_item')];
        this.medias = [...this.el.querySelectorAll('.c-carousel_medias_item')];
        this.maxIndex = this.items.length - 1;

        if (this.type == 'multiple') {
            this.showItem(0);
            this.initInterval();

            onWidthResize(() => {
                this.resizeCurrentItemContent()
            });
        }
    }

    getProgressBar(index) {
        return this.items[index]?.querySelector('.c-carousel_contents_item_progress');
    }

    resetAllProgress() {
        this.progressAnim?.kill();
        this.progressAnim = null;

        this.items.forEach((item) => {
            const bar = item.querySelector('.c-carousel_contents_item_progress');
            if (bar) {
                gsap.killTweensOf(bar);
                gsap.set(bar, { scaleX: 0 });
            }
        });
    }

    playProgress(index) {
        this.resetAllProgress();

        const bar = this.getProgressBar(index);
        if (!bar) return;

        this.progressAnim = gsap.to(bar, {
            scaleX: 1,
            ease: 'none',
            duration: this.duration
        });
    }

    resetProgress(index) {
        const bar = this.getProgressBar(index);
        if (!bar) return;

        gsap.killTweensOf(bar);
        gsap.to(bar, {
            scaleX: 0,
            ease: 'expo.out',
            duration: 0.4
        });
    }

    initInterval() {
        this.interval = setInterval(() => {
            let newIndex = this.currentIndex == this.maxIndex ? 0 : this.currentIndex + 1;
            this.showItem(newIndex);
        }, this.duration * 1000);
    }

    resizeCurrentItemContent() {
        let currentItem = this.items[this.currentIndex];
        let contentHeight = currentItem.querySelector('.c-carousel_contents_item_content_inner').offsetHeight;
        currentItem.querySelector('.c-carousel_contents_item_content').style.height = contentHeight + 'px';
    }

    activateItem(e) {
        let target = e.currentTarget;
        let index = parseInt(target.getAttribute("data-index"));
        this.showItem(index, true);
    }
    
    showItem(index, force = false) {
        if (this.currentIndex == index) {
            return;
        }

        if (force) {
            clearInterval(this.interval);
            this.progressAnim?.kill();
            this.initInterval();
        }

        let oldItem = this.items[this.currentIndex];
        let oldMedia = this.medias[this.currentIndex];

        if (oldItem) {
            gsap.to(oldItem.querySelector('.c-carousel_contents_item_content'), {
                height: 0,
                ease: 'expo.out',
                duration: 0.8,
                onComplete: () => { 
                    this.call('resize', 'Scroll');
                }
            });
            oldItem.classList.remove('-active');

            this.resetProgress(this.currentIndex);
        }
        if (oldMedia) {
            oldMedia.classList.remove('-active');
            this.pauseMedia(oldMedia);
        }

        this.currentIndex = index;
        this.playProgress(index);

        let newItem = this.items[this.currentIndex];
        let newMedia = this.medias[this.currentIndex];
        let contentHeight = newItem.querySelector('.c-carousel_contents_item_content_inner').offsetHeight;
        
        newItem.classList.add('-active');
        newMedia.classList.add('-active');

        this.playMedia(newMedia);

        gsap.to(newItem.querySelector('.c-carousel_contents_item_content'), {
            height: contentHeight,
            ease: 'expo.out',
            duration: 0.8,
            onComplete: () => { 
                this.call('resize', 'Scroll');
            }
        });
    }

    playMedia(mediaWrap) {
        if (mediaWrap.querySelector('.c-media').classList.contains('-video')) {
            if (mediaWrap.querySelector('video')) {
                mediaWrap.querySelector('video').play();
            }
        } else if (mediaWrap.querySelector('.c-media').classList.contains('-lottie')) {
            let lottieId = mediaWrap.querySelector('.c-media_lottie').getAttribute('data-lottie-id');
            let lottieAnim = getLottieById(lottieId);
            if (lottieAnim) {
                lottieAnim.play();
            }
        }
    }

    pauseMedia(mediaWrap) {
        if (mediaWrap.querySelector('.c-media').classList.contains('-video')) {
            if (mediaWrap.querySelector('video')) {
                mediaWrap.querySelector('video').pause();
            }
        } else if (mediaWrap.querySelector('.c-media').classList.contains('-lottie')) {
            let lottieId = mediaWrap.querySelector('.c-media_lottie').getAttribute('data-lottie-id');
            let lottieAnim = getLottieById(lottieId);
            if (lottieAnim) {
                lottieAnim.pause();
            }
        }
    }
    
}
